




























































/**
 * @copyright       Palace Resorts
 * @description     Componente de la pantalla princiapl de Reportes
 * @author          CCHAN
 * @creationDate    20/09/2021
 */
import GlobalMixin from "@/mixins/global";
import Card from "@/components/Card/Card.vue";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma.
  components: {
    // Incluimos el layout que utilizará este módulo
    Card,
  },
  data: () => {
    return {
      // GENERAL
      moduleName: "MAIN_REPORT",
      // Pendientes a subir documentos
      proveedorDocPendientes: "",
      proveedorDocPendientesPorc: "0",
      proveedorDocPendientesColor: "success",
      proveedorDocPendientesIcon: "mdi-alert",
      // Pendientes a autorizar
      proveedorDocPendientesA: "",
      proveedorDocPendientesPorcA: "0",
      proveedorDocPendientesColorA: "success",
      proveedorDocPendientesIconA: "mdi-alert",
      // Documentos rechazados
      proveedorDocRechazados: "",
      proveedorDocRechazadosPorc: "0",
      proveedorDocRechazadosColor: "success",
      proveedorDocRechazadosIcon: "mdi-alert",
    };
  },
  methods: {
    // GENERAL
    async int() {
      // Obtener proveedores con documentos pendientes a subir
      //await this.getProveedoresDocPendientes();
      // Obtener proveedores con documentos pendientes a autorizar
      await this.getProveedoresDocPendientesAutorizar();
      // Obtener proveedores con documentos rechazados
      await this.getProveedoresDocRechazados();
    },
    // Metodo para obtener proveedores con documentos pendientes a subir
    async getProveedoresDocPendientes() {
      dataService.getMainReport().then((Response: ResponseData) => {
        if (Response.data.data.length > 0) {
          let proveedorTotal = Response.data.data[0].hasOwnProperty(
            "totalProveedoresSub"
          )
            ? Response.data.data[0].totalProveedoresSub
            : 0;
          let totalProveedoresSubDocPen = Response.data.data[0].hasOwnProperty(
            "totalProveedorDocPen"
          )
            ? Response.data.data[0].totalProveedorDocPen
            : 0;
          this.proveedorDocPendientes = totalProveedoresSubDocPen.toString();
          if (this.proveedorDocPendientes == "0") {
            this.proveedorDocPendientesColor = "success";
            this.proveedorDocPendientesIcon = "mdi-check-circle";
          } else {
            let porcentaje = Math.round(
              (totalProveedoresSubDocPen * 100) / proveedorTotal
            );
            const objPorcentaje = this.getColorIconPorcentaje(porcentaje);
            this.proveedorDocPendientesColor = objPorcentaje.color;
            this.proveedorDocPendientesIcon = objPorcentaje.icon;
            this.proveedorDocPendientesPorc =
              porcentaje == Infinity ? "" : porcentaje.toString();
          }
        }
      });
    },
    // Metodo para obtener proveedores con documentos pendientes a autorizar
    async getProveedoresDocPendientesAutorizar() {
      dataService.getMainReportPending().then((Response: ResponseData) => {
        if (Response.data.data.length > 0) {
          let proveedorTotal = Response.data.data[0].hasOwnProperty(
            "totalProveedoresSub"
          )
            ? Response.data.data[0].totalProveedoresSub
            : 0;
          let totalProveedorDocPenA = Response.data.data[0].hasOwnProperty(
            "totalProveedorDocPenA"
          )
            ? Response.data.data[0].totalProveedorDocPenA
            : 0;
          this.proveedorDocPendientesA = totalProveedorDocPenA.toString();
          if (this.proveedorDocPendientesA == "0") {
            this.proveedorDocPendientesColorA = "success";
            this.proveedorDocPendientesIconA = "mdi-check-circle";
          } else {
            let porcentaje = Math.round(
              (totalProveedorDocPenA * 100) / proveedorTotal
            );
            const objPorcentaje = this.getColorIconPorcentaje(porcentaje);
            this.proveedorDocPendientesColorA = objPorcentaje.color;
            this.proveedorDocPendientesIconA = objPorcentaje.icon;
            this.proveedorDocPendientesPorcA =
              porcentaje == Infinity ? "" : porcentaje.toString();
          }
        }
      });
    },
    // Metodo para obtener proveedores con documentos rechazados
    async getProveedoresDocRechazados() {
      dataService.getMainReportRefuse().then((Response: ResponseData) => {
        if (Response.data.data.length > 0) {
          let proveedorTotal = Response.data.data[0].hasOwnProperty(
            "totalProveedoresSub"
          )
            ? Response.data.data[0].totalProveedoresSub
            : 0;
          let totalProveedorDocRechazados =
            Response.data.data[0].hasOwnProperty("totalProveedorDocRechazados")
              ? Response.data.data[0].totalProveedorDocRechazados
              : 0;
          this.proveedorDocRechazados = totalProveedorDocRechazados.toString();
          if (this.proveedorDocRechazados == "0") {
            this.proveedorDocRechazadosColor = "success";
            this.proveedorDocRechazadosIcon = "mdi-check-circle";
          } else {
            let porcentaje = Math.round(
              (totalProveedorDocRechazados * 100) / proveedorTotal
            );
            const objPorcentaje = this.getColorIconPorcentaje(porcentaje);
            this.proveedorDocRechazadosColor = objPorcentaje.color;
            this.proveedorDocRechazadosIcon = objPorcentaje.icon;
            this.proveedorDocRechazadosPorc =
              porcentaje == Infinity ? "" : porcentaje.toString();
          }
        }
      });
    },
    getColorIconPorcentaje(porcentaje: number) {
      let objPorcentaje = {
        color: "success",
        icon: "mdi-check-circle",
      };
      if (porcentaje >= 5) {
        objPorcentaje = {
          color: "amber",
          icon: "mdi-alert",
        };
      }
      if (porcentaje >= 50) {
        objPorcentaje = {
          color: "orange accent-3",
          icon: "mdi-alert",
        };
      }
      if (porcentaje >= 80) {
        objPorcentaje = {
          color: "red",
          icon: "mdi-alert",
        };
      }
      return objPorcentaje;
    },
  },
  mounted() {
    this.int();
  },
});
